import { QueryTuple, useLazyQuery } from '@apollo/client';
import { CrewMemberList, PagingInput, SearchCrewInput } from '@bechtel/types';
import { GET_CREW_HIERARCHY } from '@bechtel/client-gql';

export function useCrewHierachy(
  fetchFromNetwork?: boolean
): QueryTuple<{ crewMembers: CrewMemberList }, { input?: SearchCrewInput; paging?: PagingInput }> {
  const response = useLazyQuery<{ crewMembers: CrewMemberList }, { input?: SearchCrewInput; paging?: PagingInput }>(
    GET_CREW_HIERARCHY,
    fetchFromNetwork
      ? {
          notifyOnNetworkStatusChange: true,
          nextFetchPolicy: 'cache-first',
          fetchPolicy: 'network-only',
        }
      : {
          notifyOnNetworkStatusChange: true,
          nextFetchPolicy: 'cache-first',
        }
  );
  return response;
}
